<script>
  import {M} from "../../../external";
  export let data;
  export let onRemove;
  export let onClick;

  let icon = "error_outline";
  let message = "Error!";

  $: {
    if (!icon || !data || !data.type) {
      icon = "error_outline";
      message = "Error!";
    }
    switch (data.type) {
      case "LIST_ADD":
        icon = "person_add";
        message = M.LIST_ADD_GOAL;
        break;
      case "LIST_REMOVE":
        icon = "person_remove";
        message = M.LIST_REMOVE_GOAL;
        break;
      case "MEMBER_GROUP_ADD":
        icon = "person_add";
        message = M.MEMBER_GROUP_ADD_GOAL;
        break;
      case "MEMBER_GROUP_REMOVE":
        icon = "person_remove";
        message = M.MEMBER_GROUP_REMOVE_GOAL;
        break;
      case "EMAIL_OPEN":
        icon = "drafts";
        message = M.EMAIL_OPEN_GOAL;
        break;
      case "EMAIL_CLICK":
        icon = "insert_link";
        message = M.EMAIL_CLICK_GOAL;
        break;
      case "PAGE_VISIT":
        icon = "visibility";
        message = M.PAGE_VISIT_GOAL;
        break;
      case "TAG_ADD":
        icon = "label";
        message = M.TAG_ADD_GOAL;
        break;
      case "TAG_REMOVE":
        icon = "label_off";
        message = M.TAG_REMOVE_GOAL;
        break;
      case "PROPERTY_CHANGE":
        icon = "assignment_ind";
        message = M.PROPERTY_CHANGE_GOAL;
        break;
      case "PURCHASE_MAKE":
        icon = "shopping_basket";
        message = M.PURCHASE_MAKE_GOAL;
        break;
      case "ORDER_STATUS_CHANGE":
        icon = "local_shipping";
        message = M.ORDER_STATUS_CHANGES;
        break;
      case "CART_ABANDON":
        icon = "remove_shopping_cart";
        message = M.CHECK_CART_ABANDON_GOAL;
        break;
      case "COMMENT_REACTION":
        icon = "add_reaction"
        message = M.REACTION;
        break;
      case "POLL_REACTION":
        icon = "ballot"
        message = M.POLL_REACTION;
        break;
      case "VIDEO_STARTED":
        icon = "play_circle";
        message = M.VIDEO_STARTED;
        break;
      case "VIDEO_PORTION_WATCHED":
        icon = "play_circle";
        message = M.VIDEO_PORTION_WATCHED;
        break;
      case "VIDEO_COMPLETED":
        icon = "play_circle";
        message = M.VIDEO_COMPLETED_AUT;
        break;
      case "CIRCLE_ENROLL":
        icon = "input";
        message = M.TRIGGER_ENROLLED;
        break;
      case "CIRCLE_CONTENT_COMPLETED":
        icon = "check_circle";
        message = M.TRIGGER_COMPLETED_CIRCLE_CONTENT;
        break;
      case "GOAL_REACHED":
        icon = "emoji_events";
        message = M.GOAL_REACHED;
        break;
      default:
        icon = "error_outline";
        message = M.ERROR;
        break;
    }
  }
</script>

<li>
  <div id={data.name} class="add-automation-rule flex align-center">
    <span class="circle-automation-icon blue-border"
          class:material-icons-outlined={icon !== 'input'}
          class:material-icons={icon === 'input'}>{icon}</span>
    <div class="flex-1" on:click={onClick}>
      {#if data.name}
        <span class="col20 f-left light-gray-text t-left mb-5">{message}</span>
        <h5>{data.name}</h5>
      {:else}
        <h5>{message}</h5>
      {/if}
    </div>
    {#if data.type !== "CART_ABANDON"}
      <a on:click={onClick} class="mr-5"><span class="material-icons-outlined"> settings </span></a>
    {/if}
    <a on:click={onRemove} class="mr-5"><span class="material-icons-outlined"> delete </span></a>
  </div>
</li>
